module.exports = __webpack_public_path__ + "img/lvyingjiang.f97b1b90.jpg";